var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-panel"},[_c('div',{staticClass:"chart-body"},[_c('div',{staticStyle:{"width":"600px","height":"250px"},style:(_vm.autoDisplay),attrs:{"id":"trending"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }